/**
 * For Premium
 * In Progress - ACTIVE + WITH SOME BIDS
 */
export enum LOAD_STATUS {
    ALL = -1, //Dummy status - just incase to use in dropdown option
    EXPIRED = 0,
    COMPLETED = 1,
    ACTIVE = 3,
    IN_TRANSIT = 4,
    STAND_BY = 5,
    CANCELLED = 6,
    UNDER_REVIEW = 9999
}

export const ALL_LOAD_STATUS = [
    LOAD_STATUS.EXPIRED,
    LOAD_STATUS.COMPLETED,
    LOAD_STATUS.ACTIVE,
    LOAD_STATUS.IN_TRANSIT,
    LOAD_STATUS.STAND_BY,
    LOAD_STATUS.CANCELLED
];

export enum LOAD_STATUS_TEXT {
    ALL = "All",
    EXPIRED = "Expired",
    COMPLETED = "Completed",
    ACTIVE = "Active",
    IN_TRANSIT = "In Transit",
    STAND_BY = "Stand By",
    CANCELLED = "Cancelled",
    UNDER_REVIEW = "Under Review"
}

export const LOAD_STATUS_TEXT_MAP = {
    [LOAD_STATUS.ALL]: "All",
    [LOAD_STATUS.EXPIRED]: "Expired",
    [LOAD_STATUS.COMPLETED]: "Completed",
    [LOAD_STATUS.ACTIVE]: "Active",
    [LOAD_STATUS.IN_TRANSIT]: "In Transit",
    [LOAD_STATUS.STAND_BY]: "Supplier confirmed",
    [LOAD_STATUS.CANCELLED]: "Cancelled",
    [LOAD_STATUS.UNDER_REVIEW]: "Under Review"
};

export const ACTION_BY_LOAD_STATUS = {
    UPDATE_LOADING_TIME: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY, LOAD_STATUS.IN_TRANSIT],
    CS_ATTACH_LORRY: [LOAD_STATUS.IN_TRANSIT],
    CS_LOAD_ASSIGN: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY]
};

export type ClubbedLoadStatusType = keyof typeof ClubbedLoadStatus;

export const ClubbedLoadStatus = {
    ALL_LOADS: {
        label: "All Loads",
        value: ALL_LOAD_STATUS
    },
    ALL_NON_EXPIRED_LOADS: {
        label: "All Non-Expired Loads",
        value: ALL_LOAD_STATUS.filter((ldSt) => ldSt != LOAD_STATUS.EXPIRED)
    },
    ACTIVE_LOADS: {
        label: "Active + Supplier Confirmed",
        value: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY]
    },
    WENT_INTRANSIT: {
        label: "Went In-Transit",
        value: [LOAD_STATUS.IN_TRANSIT, LOAD_STATUS.COMPLETED, LOAD_STATUS.CANCELLED]
    },
    ACTIVE_WITH_BOOKING_CONFIRMED: {
        label: "Active + Booking Paid",
        value: [LOAD_STATUS.ACTIVE],
        flags: {
            booking_confirmed: true
        }
    },
    BOOKING_CONFIRMED: {
        label: "All + Booking Paid",
        value: ALL_LOAD_STATUS,
        flags: {
            booking_confirmed: true
        }
    },
    ACTIVE: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.ACTIVE],
        value: [LOAD_STATUS.ACTIVE]
    },
    STAND_BY: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.STAND_BY],
        value: [LOAD_STATUS.STAND_BY]
    },
    EXPIRED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.EXPIRED],
        value: [LOAD_STATUS.EXPIRED]
    },
    IN_TRANSIT: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.IN_TRANSIT],
        value: [LOAD_STATUS.IN_TRANSIT]
    },
    COMPLETED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.COMPLETED],
        value: [LOAD_STATUS.COMPLETED]
    },
    CANCELLED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.CANCELLED],
        value: [LOAD_STATUS.CANCELLED]
    }
};
